import { Responsibility } from '@lmc/ts-common'

// Mirror of the canonical permission ObjectIds defined in the care-management
// backend at `packages/care-management/src/services/internal/authz/permissions.repository.ts`.
// `MANAGE_SAFEGUARDING` is sourced from the published enum in @lmc/ts-common so
// the two stay in sync; the other four are duplicated here because the backend
// has not yet exported them. If you change any of these, update the backend
// repo too (or vice-versa).
export const PermissionId = {
  MANAGE_SAFEGUARDING: Responsibility.SafeguardingOfficer,
  VIEW_AND_RESEND_TEAM_MEMBERS: '67d075447db5600ce4464038',
  CREATE_AND_EDIT_SERVICE_USER_DATA: '67bca998a5e842c2c928e925',
  CREATE_AND_MANAGE_INCIDENTS: '67d0753a1617bb728a503eb8',
  VIEW_REPORTS_AND_EXPORT_HOME_DATA: '67d0753f7898785cb40ce4b6'
} as const

export type PermissionIdValue = (typeof PermissionId)[keyof typeof PermissionId]

export const PermissionsTemplateId = {
  CARE_MANAGEMENT: '67bed5825bd82a2e74a29674'
} as const

// The CARE_MANAGEMENT template implicitly grants these permissions to a user
// (via the CASL resolver, regardless of the user's own `permissions` array).
// The template also bundles four additional permissions
// (CREATE_AND_EDIT_CARE_DELIVERY, MANAGE_AND_SEND_NOTICEBOARD,
// MANAGE_CARE_PLANNING, MANAGE_HEALTH_RECORDS) that don't surface as chips,
// so they're omitted here.
export const CARE_MANAGEMENT_IMPLICIT_PERMISSIONS: readonly PermissionIdValue[] =
  [
    PermissionId.VIEW_AND_RESEND_TEAM_MEMBERS,
    PermissionId.CREATE_AND_EDIT_SERVICE_USER_DATA,
    PermissionId.CREATE_AND_MANAGE_INCIDENTS,
    PermissionId.VIEW_REPORTS_AND_EXPORT_HOME_DATA
  ]
